import { RootAppState } from '../types';

export const getResourceContents = (state: RootAppState) => state.resource.resourceContents;

export const getResourceTitle = (state: RootAppState) => state.resource.title;

export const getResourceType = (state: RootAppState) => state.resource.resourceType;

export const getResourceId = (state: RootAppState) => state.resource.id;
